// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'recurring-expense.frequency-once': 'Once',
    'recurring-expense.frequency-weekly': 'Weekly',
    'recurring-expense.frequency-bi-weekly': 'Bi-weekly',
    'recurring-expense.frequency-monthly': 'Monthly',
    'recurring-expense.frequency-monthly-specific-day': 'Monthly with set day',
    'recurring-expense.frequency-bi-monthly': 'Bi-monthly',
    'recurring-expense.frequency-quarterly': 'Quarterly',
    'recurring-expense.frequency-semi-annually': 'Semi-annually',
    'recurring-expense.frequency-yearly': 'Yearly',

    'recurring-expense.page.title': 'Recurring Expenses',
    'recurring-expense.page.search_results': 'Search Results',
    'recurring-expense.page.create.title': 'New Recurring Expense',
    'recurring-expense.page.search.title': 'Find Recurring Expenses',
    'recurring-expense.page.edit.title': 'Edit Recurring Expense',
    'recurring-expense.page.all': 'All',

    'recurring-expense.button.cancel': 'Cancel',
    'recurring-expense.button.continue': 'Continue',
    'recurring-expense.button.filter': 'Filter',
    'recurring-expense.button.sort': 'Sort',
    'recurring-expense.button.select': 'Select',
    'recurring-expense.button.find': 'Find Recurring Expenses',
    'recurring-expense.button.search': 'Apply',
    'recurring-expense.button.create': 'Publish',
    'recurring-expense.button.draft': 'Save as Draft',
    'recurring-expense.button.new': 'New Recurring Expense',
    'recurring-expense.button.cancel_expense': 'Void',
    'recurring-expense.button.save': 'Save Changes',
    'recurring-expense.button.delete': 'Permanently Delete',
    'recurring-expense.button.edit': 'Edit',
    'recurring-expense.button.reset': 'Reset',

    'recurring-expense.placeholder.search': 'Search recurring expenses',

    'recurring-expense.link.create_first_expense': 'Click here to create your first recurring expense',
    'recurring-expense.link.recurring-expenses': ' Return to Recurring Expenses',
    'recurring-expense.link.retry': 'Click here to retry',

    'recurring-expense.checkbox.all': 'Check All',
    'recurring-expense.checkbox.actions_label': 'with selected',

    'recurring-expense.label.title': 'Title',
    'recurring-expense.label.start_date': 'Start Date',
    'recurring-expense.label.end_date': 'End Date',
    'recurring-expense.label.next_run_date': 'Next Run Date',
    'recurring-expense.label.day': 'Recurrence Day',
    'recurring-expense.label.frequency': 'Frequency',

    'recurring-expense.label.expense_action': 'After Creation',
    'recurring-expense.label.save_as_draft': 'Save as Draft Expense',
    'recurring-expense.label.create_as_new_expense': 'Post as New Expense',

    'recurring-expense.label.recurring_expense_number': 'Recurring Expense No',
    'recurring-expense.label.status': 'Status',

    'recurring-expense.sort.field_label': 'Field',
    'recurring-expense.sort.direction_label': 'Direction',
    'recurring-expense.sort.direction_ascending': 'Ascending',
    'recurring-expense.sort.direction_descending': 'Descending',

    'recurring-expense.modal.title.recurring_expense_cancel': 'Void Recurring Expense',
    'recurring-expense.modal.message.recurring_expense_cancel': 'Are you sure that you want to void this recurring expense? This action cannot be undone.',

    'recurring-expense.modal.title.past_start_date': 'Are you Backdating?',
    'recurring-expense.modal.message.past_start_date': 'The start date is in the past. This schedule may generate historical transactions when it runs. Do you want to continue?',

    'recurring-expense.success.message.recurring_expense_created': 'Your recurring expense has been created',
    'recurring-expense.success.message.recurring_expense_updated': 'Your recurring expense has been updated',
    'recurring-expense.success.message.recurring_expense_cancelled': 'Your recurring expense has been cancelled',

    'recurring-expense.error.message.error_loading_page': 'Sorry, there was an error loading recurring expense. | Sorry, there was an error loading recurring expenses.',
};
